// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-datatable-resizable-table>.p-datatable-tbody>tr>td{white-space:normal!important}.vue-json-pretty{font-family:monospace;background:#282c34;color:#fff;padding:15px;border-radius:8px;overflow-x:auto}", ""]);
// Exports
module.exports = exports;
